import { SVGAsset } from "res";

import { useModel, useRoute } from "@bcm-dev/bcms-vite";
import { Biller, Profile } from "model";

import "./styles.css";

export default function FindBillsWidget(props) {
  const model = useModel();
  const navigate = useRoute();

  const profile = Profile.init(model.profile);
  const onClick = evt => navigate(`/billDiscoveryWorkflow/${ model.profile.agreedToDiscovery === "true" ? "1" : "0" }`);

  return(
    <div className="find-bills-widget">
      { profile.agreedToDiscovery && <AddMyBillsView onClick={ onClick } /> }
      { !profile.agreedToDiscovery && <FindMyBillsView onClick={ onClick } /> }
    </div>
  );
}

export function FindMyBillsView(props) {
  return(
    <div className="find-my-bills-view flex-container flex-horizontal align-center">
      <SVGAsset id="MagnifyingGlassIcon" className="set-width left-icon" />
      <div className="flex-container flex-vertical flex-width">
        <h2 className="main-text">Try the new way to quickly find your bills</h2>
        <p className="sub-text">You decide which ones -- we'll get the info so it's fast and convenient.</p>
      </div>
      <div onClick={ props.onClick } className="clickable flex-container set-width align-center">
        <h2 className="main-text set-width show-on-desktop link" data-point="Find_My_Bills_Link">Find my bills</h2>
        <SVGAsset id="RightChevronIcon" className="set-width right-icon clickable link" data-point="Find_My_Bills_Chevron"/>
      </div>
    </div>
  );
}

export function AddMyBillsView(props) {
  const billers = Biller.initAll().filter(item => item.addType === "verification_add" || item.addType === "quick_add", []);

  return(
    <div className="add-my-bills-view flex-container flex-horizontal align-center">
      <SVGAsset id="MagnifyingGlassIcon" className="set-width left-icon" />
      <div className="flex-container flex-vertical flex-width">
        <h2 className="main-text" data-point="Add_My_Bills_Found">We found { billers.length } bills</h2>
        <p className="sub-text">Add your bills here to pay them in one place.</p>
      </div>
      <h2 className="main-text set-width show-on-desktop clickable" onClick={ props.onClick }>Add my bills</h2>
      <SVGAsset id="RightChevronIcon" className="set-width right-icon clickable" onClick={ props.onClick } />
    </div>
  );
}